module.exports = __webpack_public_path__ + "img/20200311104150745.e523f0ae.jpg";